import React, { useEffect, memo, useState } from 'react';
import ReactJson from 'react-json-view';
import JSONPretty from 'react-json-pretty';

import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SwipeableViews from 'react-swipeable-views';
import ProductSummary from './ProductSummary';
import Neighbourhood from './Neighbourhood';
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const ProductView = ({ item, setOpen }) => {

    const TabPanel = ({ children, value, index, ...other }) => {
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };


    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.paper,
        },
    }));

    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    let view = <div />

    if (item) {
        //resp = <ReactJson src={item} /> //this is too damn slow...
        let resp = (<JSONPretty id="json-pretty" data={item}></JSONPretty>);
        console.log(item);
        view = (
            <div className={classes.root}>
                <AppBar position="static">
                    {/*<div className={classes.drawerHeader}>*/}
                    {/*    <IconButton onClick={() => setOpen(a => !a)}>*/}
                    {/*        <ChevronRightIcon />*/}
                    {/*    </IconButton>*/}
                    {/*</div>*/}
                    <div style={{display:"flex"}}>
                        <IconButton onClick={() => setOpen(a => !a)} style={{ "align": "right" }} color="secondary">
                            <ChevronRightIcon />
                        </IconButton>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered>
                            <Tab label="Summary" {...a11yProps(0)} />
                            <Tab label="Neighbourhood" {...a11yProps(1)} />
                            <Tab label="Debug" {...a11yProps(2)} />
                        </Tabs>
                    </div>
                </AppBar>
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <ProductSummary data={item.data} />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Neighbourhood data={item.data} />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    {/*<p>epcData.tenure {resp.data.epcData.tenure}</p>*/}
                    {/*<p>plotMetres {resp.data?.plotMetres}</p>*/}
                    {/*<p>locationAccurate {resp.data?.locationAccurate}</p>*/}
                    {/*<p>address {resp.data?.address}</p>*/}
                    {resp}
                </TabPanel>
                <br /> <br />
            </div>);
    }

    return (
        <div>
            {view}
        </div>
    );
}

export default memo(ProductView);